module.exports = __webpack_public_path__ + "static/media/ic1.1f424e03.jpg";